import { useState } from 'react';

export default function AgeGate({ children }) {
  const [isConfirmed, setIsConfirmed] = useState(false);

  if (isConfirmed) {
    return children;
  }

  return (
    <div className="modal-root" role="dialog" aria-modal="true" aria-label="Verificación de edad">
      <div className="modal-backdrop" />
      <section className="auth-modal age-gate">
        <div className="brand-mark brand-mark--large">
          <img src="/logo.png" alt="OG Canna" />
        </div>
        <p className="eyebrow">Verificación de edad</p>
        <h2>¿Eres mayor de 18 años?</h2>
        <p className="muted-copy">
          Esta web vende productos de cannabis legal solo a personas adultas. Si no lo eres, no podrás acceder.
        </p>
        <div className="age-gate__actions">
          <button className="button button--primary" type="button" onClick={() => setIsConfirmed(true)}>
            Sí, soy mayor de 18
          </button>
          <button
            className="button button--ghost"
            type="button"
            onClick={() => {
              window.location.href = 'https://www.google.com';
            }}
          >
            No
          </button>
        </div>
      </section>
    </div>
  );
}
